export enum SiteInfoFields {
  SMC = 'smc',
  SMCName = 'SMCName',
  SMCId = 'SMCId',
  Site = 'site',
  Contact = 'contact',
  Address = 'address',
  OptionalAddress = 'optionalAddress',
  Zip = 'zip',
  State = 'state',
  City = 'city',
  CityCode = 'cityCode',
  Country = 'country',
  PhoneCode = 'phoneCode',
  Phone = 'phone',
  Cell = 'cell',
  SiteType = 'siteType',
  Note = 'note',
  SITE_OTHER_CITY = 'siteOtherCity',
}

export const JobBidTableColumns = [
  { key: 'BidCreationDate', label: 'Date' },
  { key: 'JobId', label: 'Job #' },
  { key: 'SiteName', label: 'Site' },
  { key: 'City', label: 'Site City' },
  { key: 'CustomerId', label: 'Cust #' },
  { key: 'customerName', label: 'Customer' },
  { key: 'serialToolTip', label: 'Serial #' },
  { key: 'modelToolTip', label: 'Model' },
  { key: 'TotalBid', label: 'TotalBid' },
];
